var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000096760191985146263340000002915627641460879534_);}\n\t.st1{fill:#4DA6EA;}\n\t.st2{fill:#DD3E46;}\n\t.st3{fill:#3E8051;}\n\t.st4{fill:#F9BB4B;}\n\t.st5{fill:#FFD782;}\n\t.st6{fill:#FCF05A;}\n\t.st7{fill:#F4F4E6;}\n\t.st8{fill:#F3F2F0;}\n\t.st9{fill:#143441;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M256,0c-47.2,0-91.4,12.8-129.3,35c-0.6,0.4-1.2,0.7-1.8,1.1c-0.8,0.5-1.6,1-2.4,1.5 c-0.7,0.4-1.3,0.8-2,1.2c-1.8,1.1-3.5,2.2-5.3,3.4c-0.1,0-0.1,0.1-0.2,0.1c-6.3,4.2-12.5,8.6-18.4,13.4c-0.4,0.3-0.8,0.6-1.2,0.9 c-1.2,1-2.4,1.9-3.6,2.9c-0.5,0.4-1,0.8-1.5,1.3c-1.1,1-2.2,1.9-3.4,2.9c-0.4,0.4-0.9,0.8-1.3,1.2c-1.2,1.1-2.4,2.2-3.6,3.3 c-0.3,0.3-0.6,0.5-0.9,0.8c-1.3,1.3-2.7,2.5-4,3.8c-0.1,0.1-0.3,0.3-0.4,0.4c-1.5,1.4-2.9,2.9-4.3,4.3c0,0,0,0,0,0 c-1.5,1.5-2.9,3.1-4.4,4.6c0,0,0,0,0,0c-1.3,1.4-2.7,2.9-4,4.4c-0.1,0.1-0.2,0.2-0.3,0.4l0,0c0,0,0,0,0,0l0,0 c-0.1,0.1-0.1,0.1-0.2,0.2c-6.1,6.9-11.8,14.2-17.2,21.8c-0.1,0.2-0.2,0.3-0.4,0.5c0,0,0,0,0,0C17.1,150.9,0,201.5,0,256 c0,141.4,114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050625933635688243210000015796303029339324310_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "flat",
    style: {
      clipPath: "url(#SVGID_00000050625933635688243210000015796303029339324310_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-28.5,0h674.9v512H-28.5V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-28.5,0h186.2v162.9H-28.5V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-28.5,349.1h186.2V512H-28.5V349.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.7,15.5l-75.4,66l75.4,66v15.5H140l-75.4-66l-75.4,66h-17.7v-15.5l75.4-66l-75.4-66V0h17.7l75.4,66L140,0 h17.7V15.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.1,465.5v-46.5c0-12.9,10.4-23.3,23.3-23.3h23.3l11.6,23.3h34.9v46.5H18.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.6,132.2h48.1v32.1h-48.1V132.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.7,124.2h48.1v32.1h-48.1V124.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M379.9,124.2h48.1v32.1h-48.1V124.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.8,188.3h-64.1c-14.3,33.3-14.3,70.9,0,104.2h64.1C357.6,259.2,357.6,221.5,371.8,188.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M444,188.3h-40.1c-14.3,33.3-14.3,70.9,0,104.2H444C429.7,259.2,429.7,221.5,444,188.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M251.8,293.8l-10.9-65.4l18.7,14.7l10.3,62L251.8,293.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.8,156.2h16v32.1h-16V156.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M411.9,156.2h16v32.1h-16V156.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M251.6,164.2h16v32.1h-16V164.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M585.3,453.8c-13.8,0.1-27.2-4.8-37.6-14c-13.2-12.3-33.8-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0 c-13.2-12.3-33.7-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0c-13.2-12.3-33.7-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0 c-6.3-6.1-14.7-9.4-23.5-9.3v-23.3c13.8-0.1,27.2,4.8,37.6,14c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0 c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0 c13.3,12.4,33.8,12.4,47.1,0c10.4-9.1,23.8-14.1,37.6-14v23.3c-8.8-0.1-17.2,3.3-23.5,9.3C612.5,449,599.1,454,585.3,453.8 L585.3,453.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M585.3,500.4c-13.8,0.1-27.2-4.8-37.6-14c-13.2-12.3-33.8-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0 c-13.2-12.3-33.7-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0c-13.2-12.3-33.7-12.3-47,0c-21.6,18.7-53.6,18.7-75.2,0 c-6.3-6.1-14.7-9.4-23.5-9.3v-23.3c13.8-0.1,27.2,4.8,37.6,14c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0 c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0c13.2,12.3,33.7,12.3,47,0c21.6-18.7,53.6-18.7,75.2,0 c13.3,12.4,33.8,12.4,47.1,0c10.4-9.1,23.8-14.1,37.6-14v23.3c-8.8-0.1-17.2,3.3-23.5,9.3C612.5,495.5,599.1,500.5,585.3,500.4 L585.3,500.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M76.3,162.9V0H53v162.9h-81.5v186.2h186.2V162.9H76.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M267.7,196.3h-32.1c-9.2,14.7-9.2,33.4,0,48.1h32.1C258.5,229.7,258.5,211,267.7,196.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.6,292.4l48.1,72.1H436l48.1-72.1H227.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.5,197.8h23.3v23.3H6.5V197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53,197.8h23.3v23.3H53V197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.5,197.8h23.3v23.3H99.5V197.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.5,244.4h23.3v23.3H6.5V244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53,244.4h23.3v23.3H53V244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.5,244.4h23.3v23.3H99.5V244.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M6.5,290.9h23.3v23.3H6.5V290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M53,290.9h23.3v23.3H53V290.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.5,290.9h23.3v23.3H99.5V290.9z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/pm.b79f6299405a3c3ad5f6319508988470.svg";
export { ForwardRef as ReactComponent };